import type AggregationFilter from '../store/AggregationFilter';
import BedroomsFilter from '../store/BedroomsFilter';
import FlexibleArrivalDateFilter from '../store/FlexibleArrivalDateFilter';
import HouseSearchFilters from '../store/HouseSearchFilters';
import KeywordFilter from '../store/KeywordFilter';
import PriceFilter from '../store/PriceFilter';
import TravelPartyFilter from '../store/TravelPartyFilter';

export default class SelectedFiltersToFilterMapping {
    public static map(): Map<string, CallableFunction> {
        const filters = HouseSearchFilters.getInstance();

        return new Map([
            [
                'keyword',
                (): void => {
                    const filter = filters.get(KeywordFilter.NAME) as KeywordFilter;
                    filter.clear();
                }
            ],
            [
                'adults',
                (): void => {
                    const filter = filters.get(TravelPartyFilter.NAME) as TravelPartyFilter;
                    filter.adults = 0;
                }
            ],
            [
                'children',
                (): void => {
                    const filter = filters.get(TravelPartyFilter.NAME) as TravelPartyFilter;
                    filter.children = 0;
                }
            ],
            [
                'babies',
                (): void => {
                    const filter = filters.get(TravelPartyFilter.NAME) as TravelPartyFilter;
                    filter.babies = 0;
                }
            ],
            [
                'pets',
                (): void => {
                    const filter = filters.get(TravelPartyFilter.NAME) as TravelPartyFilter;
                    filter.pets = 0;
                }
            ],
            [
                'minPrice',
                (): void => {
                    const filter = filters.get(PriceFilter.NAME) as PriceFilter;
                    filter.min = 0;
                }
            ],
            [
                'maxPrice',
                (): void => {
                    const filter = filters.get(PriceFilter.NAME) as PriceFilter;
                    filter.max = null;
                }
            ],
            [
                'flexibleArrivalDate',
                (): void => {
                    const filter = filters.get(
                        FlexibleArrivalDateFilter.NAME
                    ) as FlexibleArrivalDateFilter;
                    filter.clear();
                }
            ],
            [
                'bedrooms',
                (): void => {
                    const filter = filters.get(BedroomsFilter.NAME) as BedroomsFilter;
                    filter.clear();
                }
            ],
            [
                'aggregation',
                (name: string, value: string): void => {
                    const filter = filters.get(name) as AggregationFilter;
                    filter.remove(value);
                }
            ]
        ]);
    }
}
